module.exports = __webpack_public_path__ + "img/approved.07adc9a1.svg";